<template>
  <div class="grid">
    <div
      v-for="kachel in kacheln"
      :key="kachel.id"
      :class="['kachel', kachel.typ]"
    >
      <div class="inner-grid">
        <div :class="['cell', kachel.wochentag]">
          {{ kachel.datum  }}
        </div>
        <div class="cell">
          {{ kachel.wish }} / {{ kachel.ekz }} / {{ kachel.werf }} - {{ kachel.service }}
        </div>  
        <div class="cell">
          {{ kachel.time }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import {computed, defineComponent, ref, watch} from "vue"
  import {getNormalizedService} from "@/hooks/utils";
//#MoeB1s#DBuser
  interface Kachel {
    id: string
    datum:string
    typ: string
    wish: string
    werf: string
    ekz: string
    time: string
    wochentag: string
    service: string
  }

  export default defineComponent({
    name: "ServiceView",
    setup(props) {
      const userWishes = computed(() => props.userWishes)
      const kacheln = ref<Kachel[]>([])

      watch([userWishes], async ([newUserWishes]) => {
        kacheln.value = [];
        if (!newUserWishes) return;

        let count = 0; // Zähler für Kacheln

        for (const service of newUserWishes) {
          let _typ = "";
          const _vacation = service?.wish?.vacation || false;
          const _wishtyp = service?.wish?.shift || 0;
          const _ekz = getNormalizedService(service).split(",")[0];
          let _service = service?.service || "";
          const _work = service?.work || "";
          const _begin = service?.begin || "";
          const _end = service?.end || "";
          let _time = [_work, _begin, _end].filter(Boolean).join(" / ");
          let _wochentag = "woche";
          let _werf = 0;
          const _date = service.date;
          const _datum = new Intl.DateTimeFormat("de-DE", {
            weekday: "short",
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          })
            .format(new Date(service.date))
            .replace(",", "");
          const _wt = new Intl.DateTimeFormat("de-DE", { weekday: "short" })
            .format(new Date(service.date))
            .replace(",", "");
          if (_wt === "Sa") _wochentag = "samstag";
          if (_wt === "So") _wochentag = "sonntag";
          if (_wishtyp.toString().trim() === _ekz.toString().trim()) {
            _werf = 1;
          }
          if (_vacation) {
            _typ = "urlaub";
            _time = "";
            if (_ekz === "11") _werf = 1;
          } else {
            switch (_ekz) {
              case "0":
                _typ = "wunsch";
                break;
              case "1":
                _typ = "frueh";
                break;
              case "2":
                _typ = "mittel";
                break;
              case "3":
                _typ = "spaet";
                break;
              case "4":
                _typ = "nacht";
                break;
              case "5":
                _typ = "geteilt";
                break;
              case "10":
              case "11":
              case "12":
                _typ = "frei";
                break;
              default:
                _typ = "wunsch";
                break;
            }
          }
          
          switch (_service) {
            case "9801":
            case "9802":
            case "9803":
              _service = "9800"
              break;
          }

          const _servicekachel: Kachel = {
            id: _date,
            datum: _datum,
            ekz: _ekz,
            wish: _wishtyp,
            service: _service,
            time: _time,
            wochentag: _wochentag,
            typ: _typ,
            werf: _werf.toString(),
          };

          kacheln.value.push(_servicekachel);
          count++;

          // Nach jeder 7. Kachel eine leere Kachel hinzufügen
          if (count % 7 === 0) {
            kacheln.value.push({
              id: `dummy-${count}`,
              datum: "",
              ekz: "",
              wish: "",
              service: "",
              time: "",
              wochentag: "",
              typ: "dummy", // Klasse für leere Kachel
              werf: "",
            });
          }
        }
      });
/*
      watch([userWishes], async ([newUserWishes]) => {
        console.log("Services", userWishes)
        kacheln.value = []
        if (!newUserWishes) {
          return
        }
        for (const service of newUserWishes) {
          let _typ = ""
          const _vacation = service?.wish?.vacation || false
          const _wishtyp = service?.wish?.shift || 0
          const _ekz = getNormalizedService(service).split(',')[0]
          const _service = service?.service || ""
          const _work = service?.work || ""
          const _begin = service?.begin || ""
          const _end = service?.end || ""
          let _time = [_work, _begin, _end].filter(Boolean).join(" / ")
          let _wochentag = "woche"
          let _werf = 0
          const _date = service.date
          const _datum = new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric' })
            .format(new Date(service.date))
            .replace(',', '')
          const _wt = new Intl.DateTimeFormat('de-DE', { weekday: 'short' }).format(new Date(service.date)).replace(',', '')
          if (_wt === "Sa") {
            _wochentag = "samstag"
          }
          if (_wt === "So") {
            _wochentag = "sonntag"
          }
          if (_wishtyp.toString().trim() === _ekz.toString().trim()) {
            _werf = 1
          }
          if (_vacation) {
            _typ = "urlaub"
            _time = ""
            if (_ekz === "11") {
              _werf = 1
            }
          } else {
            switch (_ekz) {
              case "0":
                _typ = "wunsch"
                break
              case "1":
                _typ = "frueh"
                break
              case "2":
                _typ = "mittel"
                break
              case "3":
                _typ = "spaet"
                break
              case "4":
                _typ = "nacht"
                break
              case "5":
                _typ = "geteilt"
                break
              case "10":
              case "11":
              case "12":
                _typ = "frei"
                break
              default:
                _typ = "wunsch"
                break  
            }
          }
          
          const _servicekachel: Kachel = {
            id: _date,
            datum: _datum,
            ekz: _ekz,
            wish: _wishtyp,
            service: _service,
            time: _time,
            wochentag: _wochentag,
            typ: _typ,
            werf: _werf.toString()
          }
          kacheln.value.push(_servicekachel)
        }
        console.log("Kacheln", kacheln)
      })*/

      return {
        kacheln
      }
    },
    props: {
      userWishes: {
          type: Array,
          default: [],
      },
    },
  })
</script>
<style scoped>
/* Flexibles Grid-System */
.grid {
  display: grid;
  /*grid-template-columns: repeat(auto-fit, minmax(100px, 1fr)); /* Dynamische Spalten */
  grid-template-columns: repeat(7, 1fr); /* 7 Spalten auf Tablets */
  gap: 10px;
  padding: 20px;
  overflow-x: auto;
  white-space: nowrap;
}

/* Kachel-Design */
.kachel {
  /*height: 8.5em;*/
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #3b82f6; /* Blau */
  font-weight: 450;
  /*font-size: 16px;*/
  font-size: 1.5vh; /* 1.2% der Bildschirmhöhe */
  color: black;
  aspect-ratio: 1.25 / 1; 
  border-radius: 10px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
}

.dummy {
  display: none;
}
/* Inneres Grid für 3x4 Layout in jeder Kachel */
.inner-grid {
  display: grid;
  grid-template-columns: repeat(1, 1fr); /* 1 Spalten */
  grid-template-rows: repeat(3, 1fr); /* 3 Zeilen */
  gap: 0px;
  width: 100%;
}

/* Einzelne Zelle in der Mini-Tabelle */
.cell {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px;
  border-radius: 1px;
}
.woche {
  color: black;
}
.samstag {
  color: blue;
}
.sonntag {
  color: red;
}
/* Verschiedene Hintergrundfarben nach Typ */
.frueh {
  background-color: orange /* #ff9800 */
}

.mittel {
  background-color: pink/* #e91e63 */
}

.spaet {
  background-color: purple/* #9c27b0 */
}

.nacht {
  background-color: blue/* #2196f3 */
}

.geteilt {
  background-color: teal/* #009688 */
}

.frei {
  background-color: green/* #4caf50 */
}

.urlaub {
  background-color: grey 
}

.wunsch {
  background-color: #8b5cf6
}

.flex-scroll {
  display: flex;
  gap: 20px;
  overflow-x: auto;
  white-space: nowrap;
  padding: 1px;
}

/* Responsiveness */
@media (max-width: 768px) {
  .grid {
    grid-template-columns: repeat(4, 1fr); /* 2 Spalten auf Tablets */
  }

  .dummy {
    display: block;
    background-color: transparent !important;
    box-shadow: none !important;
    pointer-events: none;
  }
}

@media (max-width: 480px) {
  .kachel {
    font-size: 1.8vh; /* 1.8% der Bildschirmhöhe */
  }

  .grid {
    grid-template-columns: repeat(2, 1fr); /* 1 Spalte auf Handys */
  }

  .dummy {
    display: block;
    background-color: transparent !important;
    box-shadow: none !important;
    pointer-events: none;
  }
}
</style>